import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
import { EntityStoreName } from 'app/enums/store';
import { FeedbackEntity } from 'app/interfaces/entity';
import { apiRequestCall } from 'app/services/api';
import { ApiResource } from 'app/services/api/enums';
import { entityStoreStatus } from 'app/utils/store/entity-store-status';
import { FeedbackStoreStatus } from 'modules/feedback/store/enums';
import { CreateFeedbackRequest, FeedbackState } from 'modules/feedback/store/interfaces';

import { entityAdapter } from './adapter';

export const createFeedback = createAsyncThunk(
  `${EntityStoreName.Feedbacks}/addFeedback`,
  (data: CreateFeedbackRequest): Promise<FeedbackEntity> => {
    return apiRequestCall<FeedbackEntity, CreateFeedbackRequest>({
      params: {
        method: 'POST',
        resource: ApiResource.Feedbacks,
        data,
      },
    });
  }
);

export const clearAllReducer = (state: FeedbackState): void => {
  entityAdapter.removeAll(state);
};

export const registerReducers = (builder: ActionReducerMapBuilder<FeedbackState>): void => {
  builder
    .addCase(createFeedback.pending, (state, action) => {
      entityStoreStatus.addRequestId(state, FeedbackStoreStatus.Creating, action.meta.requestId);
    })
    .addCase(createFeedback.fulfilled, (state, action) => {
      entityAdapter.addOne(state, action.payload);
      entityStoreStatus.removeRequestId(state, FeedbackStoreStatus.Creating, action.meta.requestId);
    })
    .addCase(createFeedback.rejected, (state, action) => {
      entityStoreStatus.removeRequestId(state, FeedbackStoreStatus.Creating, action.meta.requestId);
    });
};
